import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

function LuckydrawPatrons() {
  return (
    <>
    <section className="header-sec">
        <nav className="navbar navbar-expand-lg all">
        <ul className="navbar-nav site mr-auto mt-2 mt-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/patrons"><FormattedMessage id="page.nav-winds-patrons" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/partner"><FormattedMessage id="page.nav-winds-partner" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/digi-world"><FormattedMessage id="page.nav-winds-digi" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about-us"><FormattedMessage id="page.nav-about-us" /></Link>
            </li>
            <li className="nav-item site-active">
              <Link className="nav-link" to="/luckydraw-patrons"><FormattedMessage id="page.nav-winds-luckydraw" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/testimonials"><FormattedMessage id="page.nav-winds-testimonials" /></Link>
            </li>
          </ul>
        </nav>
      </section>
      <div className="container text-center patrons">
        <div className="row">
          <div className="col-md-12">
            <img
              src={require("../../assets/img/patrons/wp-1.jpg")}
              alt="patrons"
            />
          </div>
          <div className="col-md-12">
            <img
              src={require("../../assets/img/patrons/wp-2.jpg")}
              alt="patrons"
            />
          </div>
          <div className="col-md-12">
            <img
              src={require("../../assets/img/patrons/wp-3.jpg")}
              alt="patrons"
            />
          </div>
          <div className="col-md-12">
            <img
              src={require("../../assets/img/patrons/wp-4.jpg")}
              alt="patrons"
            />
          </div>
          <div className="col-md-12" />
          <img
            src={require("../../assets/img/patrons/wp-5.jpg")}
            alt="patrons"
          />
        </div>
        <div className="col-md-12">
          <img
            src={require("../../assets/img/patrons/wp-6.jpg")}
            alt="patrons"
          />
        </div>
        <div className="col-md-12">
          <img
            src={require("../../assets/img/patrons/wp-7.jpg")}
            alt="patrons"
          />
        </div>
      </div>
    </>
  );
}

export default LuckydrawPatrons;
